var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full md:w-1/2 lg:w-1/4 px-2 py-4"},[_c('div',{staticClass:"flex flex-col items-center justify-around h-64 border"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }